import router from './index';
import storage from 'store';
import NProgress from 'nprogress';
import store from '@/store';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import 'nprogress/nprogress.css'; // 这个nprogress样式必须引入

NProgress.configure({ showSpinner: false });

const allowList = ['/user/login'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  // 如果是白名单，直接next放行
  if (allowList.includes(to.path)) {
    next();
    return;
  }
  //判断是否登录
  if (storage.get(ACCESS_TOKEN)) {
    if (allowList.includes(to.name)) {
      next({ name: to.name });
      NProgress.done();
    } else {
      if (!store.getters.addRouters.length) {
        const roles = storage.get('roles');
        if (Array.isArray(roles) && roles.length) {
          store.dispatch('GenerateRoutes', roles).then((accessedRouters) => {
            accessedRouters.forEach((route) => {
              router.addRoute(route);
            });
            const redirect = decodeURIComponent(from.query.redirect || to.path);
            if (to.path === redirect) {
              next({ ...to, replace: true });
            } else {
              // 跳转到目的路由
              next({ path: redirect });
            }
          });
        } else {
          store.dispatch('loginOut');
        }
      } else {
        next();
      }
    }
  } else {
    // Message.error('未登录或登录过期,请先登录');
    next({
      name: 'login'
    });
    NProgress.done();
  }
});
router.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/router/permission.js